<template>
    <b-card no-body>
        <b-card-body>

            <b-card bg-variant="light">
                <b-form @submit.prevent @keyup.enter="load">
                    <b-row align-v="center" class="mx-0">
                        <b-col>
                            <lg-form-input v-model="form.dadosEmpresa.pesquisaEmpresa" description=" "
                                label="Nome/CPF/CNPJ:" />
                        </b-col>
                        <b-col cols="12" sm="4" md="2" class="mt-3">
                            <lg-form-const-select v-model="form.situacao" :options="form.optionsFilterSituacao"
                                @change="load()" />
                        </b-col>
                        <b-col cols="12" sm="4" md="2">
                            <b-button id="localizar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                                variant="primary" @click="load">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" />
                                </div>
                                <b-tooltip target="localizar" title="Localizar" triggers="hover"></b-tooltip>
                            </b-button>
                            <b-button id="limpar" class="my-2" size="sm" style="height: 20px" pill variant="primary"
                                @click="limpar">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="eraser" />
                                </div>
                                <b-tooltip target="limpar" title="Limpar" triggers="hover"></b-tooltip>
                            </b-button>
                        </b-col>
                        <b-col>
                            <b-button v-if="temPrivilegioCadastro()" id="adicionarNovoEmpresa" class="mr-2 my-2"
                                size="sm" pill variant="primary" @click="abrirModalEdit">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="plus" />
                                </div>
                                <b-tooltip target="adicionarNovoEmpresa" title="Adicionar novo..."
                                    triggers="hover"></b-tooltip>

                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" @row-dblclicked="empresaSelect" :hover="true" show-empty>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(registroFmt)="{ item }">
                        {{ item.registroFmt.includes(". ") ? "" : item.registroFmt }}
                    </template>
                    <template v-slot:cell(porteEmpresa)="{ item }">
                        {{ item.porteEmpresa ? getPorteEmpresaLabel(item.porteEmpresa) : "" }}
                    </template>
                    <template v-slot:cell(situacao)="{ item }">
                        <b-form-checkbox v-if="temPrivilegioEdicao()" v-model="item.situacao"
                            @change="alteraSituacao(item)" name="check-button" switch size="lg" :value="1"
                            :unchecked-value="0" />
                    </template>
                    <template v-slot:cell(editar)="{ item }">
                        <b-button v-if="temPrivilegioEdicao()" :id="'editar-' + item.id" class="my-2" size="sm" pill
                            variant="primary" @click="abrirEditar(item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(documentos)="{ item }">
                        <b-button :id="'documentos-' + item.id" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalDocumento(item)">
                            <b-icon icon="file-earmark-text" />
                            <b-tooltip :target="'documentos-' + item.id" title="Documentos..."
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(socios)="{ item }">
                        <b-button :id="'socios-' + item.id" class="my-2" size="sm" pill variant="primary"
                            @click="abrirSocio(item)">
                            <b-icon icon="people" />
                            <b-tooltip :target="'socios-' + item.id" title="Pessoas..." triggers="hover"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(enderecos)="{ item }">
                        <b-button :id="'enderecos-' + item.id" class="my-2" size="sm" pill variant="primary"
                            @click="abrirEndereco(item)">
                            <b-icon icon="geo-alt" />
                            <b-tooltip :target="'enderecos-' + item.id" title="Endereços..."
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(enderecoEletronico)="{ item }">
                        <b-button :id="'enderecoEletronico-' + item.id" class="my-2" size="sm" pill variant="primary"
                            @click="abrirEnderecoEletronico(item)">
                            <b-icon icon="envelope" />
                            <b-tooltip :target="'enderecoEletronico-' + item.id" title="Endereço Eletrônico..."
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(telefones)="{ item }">
                        <b-button :id="'telefones-' + item.id" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalTelefone(item)">
                            <b-icon icon="telephone" />
                            <b-tooltip :target="'telefones-' + item.id" title="Telefones..."
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(contasBancarias)="{ item }">
                        <b-button :id="'contasBancarias-' + item.id" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalContaBancaria(item)">
                            <b-icon icon="credit-card" />
                            <b-tooltip :target="'contasBancarias-' + item.id" title="Contas Bancárias..."
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(cnaes)="{ item }">
                        <b-button :id="'cnaes-' + item.id" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalCnae(item)">
                            <b-icon icon="diagram-3" />
                            <b-tooltip :target="'cnaes-' + item.id" title="CNAEs..."
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        Página {{ page }} de {{ totalPage }} - {{ total }} registros
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
                <EmpresaForm v-if="showModalEdit" @close="cancelar" :isModal="true" :empresaNome="nomeEmpresa" :id="id"
                    :prefix="updatedPrefix"></EmpresaForm>
                <ModalDocumentos v-if="showModalDocumentos" @close="cancelar" :isModal="true" :id="id"
                    :empresaNome="nomeEmpresa" :codEmpresa="codigoEmpresa" :prefix="updatedPrefix"></ModalDocumentos>
                <ModalSocios v-if="showModalSocios" @close="cancelar" :codEmpresa="codigoEmpresa"
                    :empresaNome="nomeEmpresa" :isModal="true" :prefix="updatedPrefix"></ModalSocios>
                <ModalEnderecos v-if="showModalEnderecos" @close="cancelar" :isModal="true" :id="id"
                    :empresaNome="nomeEmpresa" :codEmpresa="codigoEmpresa" :prefix="updatedPrefix"></ModalEnderecos>
                <ModalEnderecoEletronico v-if="showModalEnderecoEletronico" @close="cancelar" :isModal="true" :id="id"
                    :empresaNome="nomeEmpresa" :codEmpresa="codigoEmpresa" :prefix="updatedPrefix">
                </ModalEnderecoEletronico>
                <ModalTelefone v-if="showModalTelefone" @close="cancelar" :isModal="true" :id="id"
                    :empresaNome="nomeEmpresa" :codEmpresa="codigoEmpresa" :prefix="updatedPrefix"></ModalTelefone>
                <ModalContaBancaria v-if="showModalContaBancaria" @close="cancelar" :isModal="true" :id="id"
                    :empresaNome="nomeEmpresa" :codEmpresa="codigoEmpresa" :prefix="updatedPrefix"></ModalContaBancaria>
                <ModalCnae v-if="showModalCnae" @close="cancelar" :isModal="true" :id="id"
                    :empresaNome="nomeEmpresa" :codEmpresa="codigoEmpresa" :prefix="updatedPrefix"></ModalCnae>
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalContaBancaria from "@/core/components/Modals/ModalContaBancaria.vue"
import ModalDocumentos from "@/core/components/Modals/ModalDocumentos.vue"
import ModalEnderecos from "@/core/components/Modals/ModalEndereco.vue"
import ModalEnderecoEletronico from "@/core/components/Modals/ModalEnderecoEletronico.vue"
import ModalSocios from "@/core/components/Modals/ModalSocios.vue"
import ModalTelefone from "@/core/components/Modals/ModalTelefone.vue"
import ModalCnae from "@/core/components/Modals/ModalCnae.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import EmpresaForm from "./EmpresaForm.vue"

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        EmpresaForm,
        ModalDocumentos,
        ModalSocios,
        ModalEnderecos,
        ModalEnderecoEletronico,
        ModalTelefone,
        ModalContaBancaria,
        ModalCnae,
    },
    name: 'EmpresaList',
    props: {
        processo: {
            Number,
            default: null
        },
        codEmpresa: Number,
        prefix: {
            Array,
            default: () => [],
        },
        empresas: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showModalEdit: false,
            showModalDocumentos: false,
            showModalSocios: false,
            showModalEnderecos: false,
            showModalEnderecoEletronico: false,
            showModalTelefone: false,
            showModalContaBancaria: false,
            showModalCnae: false,
            id: null,
            busy: false,
            nomeEmpresa: "",
            codigoEmpresa: this.codEmpresa || null,
            form: {
                dadosEmpresa: { nomeFantasia: "", razaoSocial: "" },
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/empresa`);
    },
    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Empresa/Pessoa"];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
        tableFields() {
            return [
                { key: "registroFmt", label: "Registro", },
                { key: "razaoSocial", label: "Razão social" },
                { key: "tipoEmpresa.descricao", label: "Tipo" },
                { key: "porteEmpresa", label: "Porte" },
                { key: "linhaFornecimento", label: "Linha de Fornecimento" },
                {
                    key: "documentos",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
                {
                    key: "socios",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
                {
                    key: "enderecos",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
                {
                    key: "enderecoEletronico",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
                {
                    key: "telefones",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
                {
                    key: "contasBancarias",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
                {
                    key: "cnaes",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
                {
                    key: "situacao",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
                {
                    key: "editar",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px;",
                    tdClass: "text-center",
                },
            ];
        },
    },
    methods: {
        getPorteEmpresaLabel(porte) {
            const porteLabels = {
                "MEI": "MEI – Microempreendedor Individual",
                "ME": "ME – Microempresa",
                "EPP": "EPP – Empresa de Pequeno Porte",
                "MEDIO": "Médio Porte",
                "GRANDE": "Grande Porte",
                "PESSOA_FISICA": "Pessoa Física",
                "ESTRANGEIRA": "Estrangeira"
            };
            return porteLabels[porte] || porte;
        },

        temPrivilegioCadastro() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },

        empresaSelect(item) {
            this.$emit("onDblClickEmpresaSelect", item);
        },
        abrirEnderecoEletronico(item) {
            this.codigoEmpresa = item.id;
            this.nomeEmpresa = item.razaoSocial;
            this.showModalEnderecoEletronico = true;
        },
        abrirEditar(item) {
            this.id = item.id;
            this.nomeEmpresa = item.razaoSocial;
            this.abrirModalEdit();
        },
        abrirSocio(item) {
            this.codigoEmpresa = item.id;
            this.nomeEmpresa = item.razaoSocial;
            this.showModalSocios = true;
        },
        abrirEndereco(item) {
            this.codigoEmpresa = item.id;
            this.nomeEmpresa = item.razaoSocial;
            this.showModalEnderecos = true;
        },
        remover(item) {
            this.$removeResource(item);
        },
        abrirModalEdit() {
            this.showModalEdit = true;
        },
        abrirModalDocumento(item) {
            this.nomeEmpresa = item.razaoSocial;
            this.codigoEmpresa = item.id;
            this.showModalDocumentos = true;
        },
        abrirModalTelefone(item) {
            this.nomeEmpresa = item.razaoSocial;
            this.codigoEmpresa = item.id;
            this.showModalTelefone = true;
        },
        cancelar() {
            this.showModalEdit = false;
            this.showModalDocumentos = false;
            this.showModalSocios = false;
            this.showModalEnderecos = false;
            this.showModalEnderecoEletronico = false;
            this.showModalTelefone = false;
            this.showModalContaBancaria = false;
            this.showModalCnae = false;
            this.id = null;
            this.nomeEmpresa = "";
            this.codigoEmpresa = null;
            this.load();
        },
        abrirModalContaBancaria(item) {
            this.nomeEmpresa = item.razaoSocial;
            this.codigoEmpresa = item.id;
            this.showModalContaBancaria = true;
        },
        abrirModalCnae(item) {
            this.nomeEmpresa = item.razaoSocial;
            this.codigoEmpresa = item.id;
            this.showModalCnae = true;
        },
        async load() {
            this.busy = true;
            var filtro = {};

            if (this.processo && this.processo != null)
                filtro.processo = this.processo;

            if (this.form.dadosEmpresa.pesquisaEmpresa) {
                filtro.pesquisaEmpresa = this.form.dadosEmpresa.pesquisaEmpresa.toLowerCase();
            }

            if (this.form.situacao != null) {
                filtro.situacao = this.form.situacao;
            }

            if (this.empresas.length > 0) {
                this.records = this.empresas.filter(record => {
                    let matchesPesquisa = true;
                    let matchesSituacao = true;

                    if (filtro.pesquisaEmpresa) {
                        matchesPesquisa = record.razaoSocial.toLowerCase().includes(filtro.pesquisaEmpresa) ||
                            record.registroFmt.toLowerCase().includes(filtro.pesquisaEmpresa);
                    }

                    if (filtro.situacao != null) {
                        matchesSituacao = record.situacao === filtro.situacao;
                    }

                    return matchesPesquisa && matchesSituacao;
                });
                this.total = this.records.length;
                this.busy = false;
                return;
            }

            await this.$loadResource({
                limit: this.perPage,
                page: this.page,
                params: filtro,
            });
            this.busy = false;
        },
        limpar() {
            this.form.dadosEmpresa.pesquisaEmpresa = null;
            this.form.situacao = 1;
            this.load();
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " a Empresa?",
                item.razaoSocial.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },

    },
};
</script>
